import React, { Component } from 'react'
import {translate} from 'react-i18next'
import { Button, Container, Row, Col, CardGroup, Card, CardBody } from 'reactstrap'
var autoBind = require('react-autobind')
class ConfirmResetPassword extends Component {
  constructor (props) {
    super(props)
    autoBind(this)
  }
  login (e) {
    this.props.history.push('/login')
    if (e) { e.preventDefault() }
  }
  render () {
    return (
      <div className='app flex-row align-items-center'>
        <Container>
          <Row className='justify-content-center'>
            <Col md='6'>
              <CardGroup>
                <Card className='p-4'>
                  <CardBody>
                    <h1>パスワード再設定</h1>
                    <div>パスワードを再設定しました。</div>
                    <Row className='p-3' style={{marginTop: '20px'}}>
                      <Button color='success' block onClick={this.login.bind(this)}>{this.props.t('OK')}</Button>
                    </Row>
                  </CardBody>
                </Card>
              </CardGroup>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}

export default translate('translations')(ConfirmResetPassword)
